import { useMutation } from "@tanstack/react-query";
import taskService from "../api/taskService";

export const useCreateTask = () => {
  const { createTask } = taskService();

  return useMutation({
    mutationKey: ["create-task"],
    mutationFn: async ({ task }) => {
      const response = await createTask(task);
      return response?.data;
    },
  });
};

export const useUpdateTask = () => {
  const { updateTask } = taskService();

  return useMutation({
    mutationKey: ["update-task"],
    mutationFn: async ({ task }) => {
      const response = await updateTask(task);
      return response.data;
    },
  });
};

export const useUpdateTaskCollaborators = () => {
  const { updateTaskCollaborators } = taskService();

  return useMutation({
    mutationKey: ["update-task-collaborators"],
    mutationFn: async ({ collaborators }) => {
      const response = await updateTaskCollaborators(collaborators);
      return response.data;
    },
  });
};

export const useAddTaskCollaborator = () => {
  const { addTaskCollaborator } = taskService();

  return useMutation({
    mutationKey: ["add-task-collaborators"],
    mutationFn: async ({ collaborators }) => {
      const response = await addTaskCollaborator(collaborators);
      return response.data;
    },
  });
};

export const useUpdateExtendedDate = () => {
  const { updateExtendedDate } = taskService();

  return useMutation({
    mutationKey: ["update-extended-date"],
    mutationFn: async ({ task }) => {
      const response = await updateExtendedDate(task);
      return response.data;
    },
  });
};

export const useBulkUpdateTasks = () => {
  const { bulkUpdateTasks } = taskService();

  return useMutation({
    mutationKey: ["bulk-update-tasks"],
    mutationFn: async ({ params, data }) => {
      const response = await bulkUpdateTasks(params, data);
      return response.data;
    },
  });
};

export const useDeleteTask = () => {
  const { deleteTask } = taskService();

  return useMutation({
    mutationKey: ["delete-task"],
    mutationFn: async ({ task }) => {
      const response = await deleteTask(task);
      return response.data;
    },
  });
};

export const useDeleteMultipleTasks = () => {
  const { deleteMultipleTasks } = taskService();

  return useMutation({
    mutationKey: ["delete-multiple-tasks"],
    mutationFn: async ({ tasks }) => {
      const response = await deleteMultipleTasks(tasks);
      return response.data;
    },
  });
};

export const useMarkTasksAsCompleted = () => {
  const { markTasksAsCompleted } = taskService();

  return useMutation({
    mutationKey: ["mark-tasks-as-completed"],
    mutationFn: async ({ taskIds }) => {
      const response = await markTasksAsCompleted(taskIds);
      return response.data;
    },
  });
};

export const useRolloverTasks = () => {
  const { rolloverTasks } = taskService();

  return useMutation({
    mutationKey: ["rollover-tasks"],
    mutationFn: async ({ tasks }) => {
      const response = rolloverTasks(tasks);
      return response.data;
    },
  });
};

export const useTasksToRollover = () => {
  const { getTasksToRollover } = taskService();

  return useMutation({
    mutationKey: ["tasks-to-rollover"],
    mutationFn: async ({ tasksToRollover }) => {
      const res = await getTasksToRollover(tasksToRollover);
      return res.data;
    },
  });
};
